import { render } from "./CardTable.vue?vue&type=template&id=65d33b74&scoped=true"
import script from "./CardTable.vue?vue&type=script&lang=js"
export * from "./CardTable.vue?vue&type=script&lang=js"

import "./CardTable.vue?vue&type=style&index=0&id=65d33b74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d33b74"]])

export default __exports__